import { loadMicroApp, prefetchApps } from 'qiankun'
import router from '@/router'
import store from '@/store'
import { MicroAppTypes } from './interface'
import { dataFinder } from '@/utils/dataFinder'
import { postKeepAliveUpdate } from './utils'

/**
 * 加载微应用方法
 * @param {*} config 应用配置
 * @returns Promise app: 应用实例
 */
export async function loadApp(config: MicroAppTypes) {
  // const { default: filesRequest } = await import('@/utils/filesRequest')
  const { default: axiosRequest, checkTokenExpired } = await import('@/utils/request')
  const targetDom = document.querySelector(`${config.container}`)
  if (!targetDom) return Promise.reject(new Error('No dom found'))

  // 挂载 window 方法，供子系统调用
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.parentWindow = window
  const app = loadMicroApp(
    {
      entry: config.entry,
      container: config.container,
      name: config.name,
      props: {
        router,
        store,
        axiosRequest,
        filesRequest: axiosRequest,
        gtag: window.gtag,
        checkTokenExpired,
        dataFinder
      }
    },
    {},
    {
      afterMount: function (app, global) {
        postKeepAliveUpdate(store.state)
        // preloadApp()
        return Promise.resolve()
      }
    }
  )
  return app
}

/**
 * 预加载子应用
 */
export const preloadApp = (function () {
  let preloadReady = false
  return function () {
    if (preloadReady) return
    const preApps = new Map()
    store.state.menu.pageList.forEach((item: { [key: string]: any }) => {
      const app = store.state.microApp.microApps.find((el: { [key: string]: any }) =>
        item.routeUrl?.startsWith(el.activeRule)
      )
      if (app && !preApps.has(app.name)) {
        preApps.set(app.name, app)
      }
    })
    process.env.NODE_ENV !== 'development' && prefetchApps([...preApps.values()])
    preloadReady = true
  }
})()
